'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherFileText } from '@subframe/core';
import type { FaturaBreakdownItem } from '../types';
import { formatarMoedaBR } from '../utils/faturaFormatters';
interface FaturaBreakdownAbaProps {
  breakdown: FaturaBreakdownItem[];
  valorTotal: number;
  descricaoLivre: string | null;
}
export function FaturaBreakdownAba(t0) {
  const $ = _c(43);
  const {
    breakdown,
    valorTotal,
    descricaoLivre
  } = t0;
  if (breakdown.length === 0) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="flex items-center gap-3"><div className="bg-brand-50 flex h-10 w-10 items-center justify-center rounded-lg"><FeatherFileText className="text-brand-600 h-5 w-5" /></div><div><h3 className="text-body-bold font-body-bold text-default-font">Cobrança manual</h3><p className="text-caption font-caption text-subtext-color">Esta fatura não está vinculada a uma apuração — foi criada manualmente.</p></div></div>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] !== descricaoLivre) {
      t2 = descricaoLivre && <div className="rounded-[12px] bg-neutral-50 p-4"><p className="text-caption font-caption text-subtext-color mb-1">Descrição</p><p className="text-body font-body text-default-font">{descricaoLivre}</p></div>;
      $[1] = descricaoLivre;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <span className="text-brand-700 text-sm font-medium">Total</span>;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    let t4;
    if ($[4] !== valorTotal) {
      t4 = formatarMoedaBR(valorTotal);
      $[4] = valorTotal;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    let t5;
    if ($[6] !== t4) {
      t5 = <div className="border-brand-100 bg-brand-50 flex items-center justify-between rounded-[12px] border px-4 py-3">{t3}<span className="text-brand-900 text-lg font-bold">{t4}</span></div>;
      $[6] = t4;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    let t6;
    if ($[8] !== t2 || $[9] !== t5) {
      t6 = <div className="bg-default-background flex flex-col gap-4 rounded-[16px] border border-solid border-neutral-200 p-6">{t1}{t2}{t5}</div>;
      $[8] = t2;
      $[9] = t5;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    return t6;
  }
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[11] !== breakdown) {
    const subtotalGeral = breakdown.reduce(_temp, 0);
    const descontoGeral = breakdown.reduce(_temp2, 0);
    t7 = "flex flex-col gap-4";
    t4 = "bg-default-background overflow-hidden rounded-[16px] border border-solid border-neutral-200";
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="grid grid-cols-[2fr_1fr_1fr_1fr] gap-4 border-b border-solid border-neutral-100 bg-neutral-50/60 px-5 py-3"><span className="text-caption-bold font-caption-bold text-subtext-color uppercase">Categoria</span><span className="text-caption-bold font-caption-bold text-subtext-color uppercase">Quantidade</span><span className="text-caption-bold font-caption-bold text-subtext-color uppercase">Valor unitário</span><span className="text-caption-bold font-caption-bold text-subtext-color text-right uppercase">Subtotal</span></div>;
      $[19] = t5;
    } else {
      t5 = $[19];
    }
    const t8 = breakdown.map(_temp3);
    if ($[20] !== t8) {
      t6 = <ul className="divide-y divide-neutral-100">{t8}</ul>;
      $[20] = t8;
      $[21] = t6;
    } else {
      t6 = $[21];
    }
    t1 = "flex flex-col gap-2 border-t border-solid border-neutral-100 bg-neutral-50/40 px-5 py-4";
    let t9;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <span className="text-subtext-color">Subtotal</span>;
      $[22] = t9;
    } else {
      t9 = $[22];
    }
    const t10 = formatarMoedaBR(subtotalGeral);
    if ($[23] !== t10) {
      t2 = <div className="flex items-center justify-between text-sm">{t9}<span className="text-default-font font-medium">{t10}</span></div>;
      $[23] = t10;
      $[24] = t2;
    } else {
      t2 = $[24];
    }
    t3 = descontoGeral > 0 && <div className="flex items-center justify-between text-sm"><span className="text-subtext-color">Descontos aplicados</span><span className="text-success-700 font-medium">− {formatarMoedaBR(descontoGeral)}</span></div>;
    $[11] = breakdown;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t1 = $[12];
    t2 = $[13];
    t3 = $[14];
    t4 = $[15];
    t5 = $[16];
    t6 = $[17];
    t7 = $[18];
  }
  let t8;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span className="text-brand-700 text-sm font-medium">Total da fatura</span>;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== valorTotal) {
    t9 = formatarMoedaBR(valorTotal);
    $[26] = valorTotal;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== t9) {
    t10 = <div className="border-brand-100 bg-brand-50 mt-2 flex items-center justify-between rounded-[12px] border px-4 py-3">{t8}<span className="text-brand-900 text-lg font-bold">{t9}</span></div>;
    $[28] = t9;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== t1 || $[31] !== t10 || $[32] !== t2 || $[33] !== t3) {
    t11 = <div className={t1}>{t2}{t3}{t10}</div>;
    $[30] = t1;
    $[31] = t10;
    $[32] = t2;
    $[33] = t3;
    $[34] = t11;
  } else {
    t11 = $[34];
  }
  let t12;
  if ($[35] !== t11 || $[36] !== t4 || $[37] !== t5 || $[38] !== t6) {
    t12 = <div className={t4}>{t5}{t6}{t11}</div>;
    $[35] = t11;
    $[36] = t4;
    $[37] = t5;
    $[38] = t6;
    $[39] = t12;
  } else {
    t12 = $[39];
  }
  let t13;
  if ($[40] !== t12 || $[41] !== t7) {
    t13 = <div className={t7}>{t12}</div>;
    $[40] = t12;
    $[41] = t7;
    $[42] = t13;
  } else {
    t13 = $[42];
  }
  return t13;
}
function _temp3(item_1, index) {
  return <li key={`${item_1.categoria}_${index}`} className="grid grid-cols-[2fr_1fr_1fr_1fr] items-center gap-4 px-5 py-4"><span className="text-body font-body text-default-font">{item_1.categoriaLabel}</span><span className="text-body font-body text-neutral-700">{item_1.quantidade}</span><span className="text-body font-body text-neutral-700">{item_1.valorUnitario != null ? formatarMoedaBR(item_1.valorUnitario) : "\u2014"}</span><div className="flex flex-col items-end"><span className="text-body-bold font-body-bold text-default-font">{formatarMoedaBR(item_1.subtotal)}</span>{item_1.desconto > 0 && <span className="text-success-700 text-caption font-caption">− {formatarMoedaBR(item_1.desconto)} desc.</span>}</div></li>;
}
function _temp2(sum_0, item_0) {
  return sum_0 + item_0.desconto;
}
function _temp(sum, item) {
  return sum + item.subtotal;
}